import { CroppedImage } from '@weee-fe/module';
import React from 'react';
import { twMerge } from 'tailwind-merge';
import { ProductCardProps } from '../../types';

interface BrandImgProps {
  renderWidth?: number;
  renderHeight?: number;
  className?: string;
}

const ProductBrandImg: React.FC<Partial<ProductCardProps> & { brandImg?: BrandImgProps }> = props => {
  const { data, brandImg = { renderWidth: 48, renderHeight: 48 } } = props;
  const { renderWidth, renderHeight, className } = brandImg;

  const imgUrl = data?.brand_img ?? '';

  if (!imgUrl) return null;

  return (
    <div
      className={twMerge(
        'relative w-11 h-11 p-2 box-border aspect-square rounded-300 border border-solid border-surface-100-hairline bg-reserved-true-white overflow-hidden',
        className
      )}
      data-role="product-image"
      data-testid="wid-product-card-image">
      <CroppedImage
        url={imgUrl}
        className="w-full h-full bg-[#ffffff] object-contain"
        configs={{ renderWidth: renderWidth ?? 48 }}
        alt={`weee_brand_img_${data?.brand_name}`}
      />
    </div>
  );
};

export default ProductBrandImg;
